// extracted by mini-css-extract-plugin
export var actionButton = "_kr-t";
export var buttonContainer = "_kr-0";
export var buttonContainer2 = "_kr-1";
export var buttonSection = "_kr-2";
export var details = "_kr-3";
export var dropdownItem = "_kr-5";
export var dropdownItemsContainer = "_kr-4";
export var fileInput = "_kr-r";
export var headerButton = "_kr-6";
export var icon = "_kr-7";
export var input = "_kr-8";
export var macroListItem = "_kr-9";
export var mainContent = "_kr-a";
export var microText = "_kr-b";
export var modal = "_kr-w";
export var optionsButton = "_kr-c";
export var paperclip = "_kr-s";
export var pillContent = "_kr-d";
export var preview = "_kr-e";
export var preview2 = "_kr-f";
export var quillEditor = "_kr-q";
export var selectedMacro = "_kr-g";
export var sidebar = "_kr-h";
export var sidebarHeader = "_kr-j";
export var sidebarList = "_kr-i";
export var sidebarListItem = "_kr-k";
export var sidebarSearch = "_kr-l";
export var snoozeDurationWrapper = "_kr-v";
export var statusPillContainer = "_kr-m";
export var tagsContainer = "_kr-n";
export var unselectedMacro = "_kr-o";
export var variable = "_kr-u";
export var wrapper = "_kr-p";